import { takeLatest, call, select, put } from 'redux-saga/effects'
import { CREATE_SUPPLIER, GET_SUPPLIERS } from './actionTypes'
import { push } from 'connected-react-router'
import { SUPPLIER } from '../../routesConstants'
import { setLoader } from '../loader/actions'
import supplierService from '../../supabaseServices/SupplierService'
import { makeSelectUser } from '../auth/selectors'
import { setSuppliers } from './actions'

export function* createSupplierSagaFn(payload) {
  try {
    yield put(setLoader(true))
    const user = yield select(makeSelectUser())
    const insertData = {
      ...payload.data,
      created_by: user.uuid,
    }
    yield put(setLoader(true))
    yield call(supplierService.createSupplier, insertData)
    const res = yield call(supplierService.getPaginatedSuppliers, 1)
    yield put(setSuppliers(res))
    yield put(push(SUPPLIER))
  } catch (error) {
    console.log(error)
  } finally {
    yield put(setLoader(false))
  }
}

export function* getSuppliersSagaFn(payload) {
  try {
    yield put(setLoader(true))
    const res = yield call(supplierService.getPaginatedSuppliers, 1)
    yield put(setSuppliers(res))
  } catch (error) {
    console.log(error)
  } finally {
    yield put(setLoader(false))
  }
}

export default function* supplierSaga() {
  yield takeLatest(CREATE_SUPPLIER, createSupplierSagaFn)
  yield takeLatest(GET_SUPPLIERS, getSuppliersSagaFn)
}
